export const ENVTokenName: string =
  process.env.REACT_APP_TOKEN_NAME || "banimodeUserProd";
